import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Chip from '@mui/material/Chip';
import { formInput, clearFormInput } from 'actions/FormActions';
import './styles/POSProductCategories.css';

const styles = {
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  }
};

class POSProductCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
    this.changeBaseCategory = this.changeBaseCategory.bind(this);
    this.changeSubCategory = this.changeSubCategory.bind(this);
  }

  componentWillMount() {
    this.props.formInput("3", 'POSBasicCategory');
  }

  componentWillReceiveProps(newProps) {
    if (this.props.selectedValue !== newProps.selectedValue) {
      this.setState({ value: newProps.selectedValue });
    }
  }

  componentWillUnmount() {
    this.props.clearFormInput('POSBasicCategory');
    this.props.clearFormInput('POSSubCategory');
  }

  handleChange = (value) => {
    this.props.clearFormInput('POSSubCategory');
    this.setState({
      value
    });
    this.props.onSelect(value);
  };

  changeBaseCategory = () => {
    this.props.clearFormInput('POSSubCategory');
    this.props.onSelect(this.state.value);
  }

  changeSubCategory = () => {
    this.props.onSelect(this.state.value);
  }

  showCategories = () => {
    let items = (this.props.items || []);
    switch (this.props.POSBasicCategory) {
      case '1':
        items = items.filter(c => c.isCannabis == true);
        break;
      case '2':
        items = items.filter(c => c.isCannabis == false);
        break;
      case '3':
        break;
      default:
        break;
    }

    items.sort((a, b) => {
      if (a.isCannabis && !b.isCannabis) {
        return -1;
      }
      if (!a.isCannabis && b.isCannabis) {
        return 1;
      }
      const aLabelLower = a.label.toLowerCase();
      const bLabelLower = b.label.toLowerCase();
      const isAAccessory = aLabelLower.startsWith("accessories");
      const isBAccessory = bLabelLower.startsWith("accessories");
      if (isAAccessory && !isBAccessory) {
        return -1;
      }
      if (!isAAccessory && isBAccessory) {
        return 1;
      }
      if (isAAccessory && isBAccessory) {
        return aLabelLower.localeCompare(bLabelLower);
      }
      return aLabelLower.localeCompare(bLabelLower);
    });

    let result = items.map((item, index) => {
      let categoryName = item.label;
      return (
        <div className={`categoryChipWrap ${this.state.value === item.value ? `active` : ``}`} key={item.value}>
          <Chip onClick={() => this.handleChange(item.value)}
            className="categoryChip"
            sx={{
              backgroundColor: this.state.value === item.value ? '#5F4BB3 ' : '#4ABA6C'
            }}
            labelcolor={this.state.value == item.value ? '#fff ' : '#fff '}
            label={categoryName} />
        </div>
      );
    });
    return result;
  }



  render() {
    const { t } = this.props; 
    return (
      <React.Fragment>
        {this.props.posShowCategories &&
          <div style={styles.wrapper} className="categoriesContainer">
            {this.showCategories()}
            {this.props.POSBasicCategory == 3 ?
              (<div className="categoryChipWrap all">
                <Chip onClick={() => this.handleChange(null)}
                  style={styles.wrapper}
                  className="categoryChip"
                  sx={{
                    backgroundColor: "#AFAEB3"
                  }}
                  label={t('pos.productCategories.all')} 
                />
              </div>)
              : null}
          </div>}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    POSSubCategory: state.form[`POSSubCategory`],
    POSBasicCategory: state.form[`POSBasicCategory`],
    posShowCategories: state.common.applicationSettings.posShowCategories
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    formInput: (value, name) => dispatch(formInput(value, name))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductCategories))